import { Map as ImmutableMap } from 'immutable';
export function isLegacySenderMap(senders) {
  return ImmutableMap.isMap(senders);
}